<template>
    <student-backend-focus-layout
        content-bg-color="gray-125"
        exit-button-text="Exit"
        v-on:exit-page-clicked="exitQuiz"
        :page-title="pageTitle"
    >
        <template #page_header>
            <div class="-mb-4">
                <div
                    v-if="$page.props.auth.user.provider_level_id == 3"
                    class="mx-auto text-center font-semibold text-gray-925 md:hidden"
                >
                    Computer-Based Linear Exam (CBLE)
                </div>
                <div
                    class="mx-auto text-center font-semibold text-gray-925 md:hidden"
                >
                    Computer Adaptive Test
                </div>
            </div>
        </template>
        <template #content>
            <div class="flex w-full flex-col gap-4">
                <div class="flex-grow">
                    <StudentComputerAdaptiveTestDebugger
                        v-if="$page.props.env !== 'production'"
                        :cat-attempt="catAttempt"
                        :minutes-remaining="minutesRemaining"
                        :question="question"
                        :time-spent="timeSpent"
                    />
                    <div
                        class="mx-auto mb-24 flex h-full w-full max-w-3xl select-none flex-col items-center justify-center gap-4 md:mb-4"
                    >
                        <div
                            class="flex items-center justify-start gap-4 rounded border border-orange-800 p-4 text-[16px] text-orange-800"
                            v-if="minutesRemaining <= 10"
                        >
                            <div class="">
                                <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 40 40"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="20"
                                        cy="20"
                                        r="20"
                                        fill="#F9D8C6"
                                    />
                                    <path
                                        d="M18.5749 12.2183L11.5166 24.0016C11.371 24.2537 11.294 24.5394 11.2932 24.8304C11.2924 25.1214 11.3678 25.4076 11.5119 25.6604C11.656 25.9132 11.8638 26.1239 12.1147 26.2715C12.3655 26.4191 12.6506 26.4984 12.9416 26.5016H27.0582C27.3492 26.4984 27.6343 26.4191 27.8851 26.2715C28.136 26.1239 28.3438 25.9132 28.4879 25.6604C28.632 25.4076 28.7074 25.1214 28.7066 24.8304C28.7058 24.5394 28.6288 24.2537 28.4832 24.0016L21.4249 12.2183C21.2763 11.9734 21.0672 11.7709 20.8176 11.6304C20.568 11.4898 20.2863 11.416 19.9999 11.416C19.7134 11.416 19.4318 11.4898 19.1822 11.6304C18.9326 11.7709 18.7235 11.9734 18.5749 12.2183Z"
                                        stroke="#CF681D"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M20 16.5V19.8333"
                                        stroke="#CF681D"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M20 23.166H20.0088"
                                        stroke="#CF681D"
                                        stroke-width="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </div>
                            <div class="">
                                You have {{ minutesRemaining }} minutes
                                remaining before your time runs out
                            </div>
                        </div>

                        <div
                            class="w-full border border-gray-300 bg-white p-8 shadow"
                        >
                            <div v-if="question">
                                <div class="mb-4 flex gap-4">
                                    <div
                                        class="rounded bg-primary-525 px-2 py-1 text-[16px] font-medium text-white"
                                    >
                                        #{{
                                            catAttempt.questions_attempted + 1
                                        }}
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                        class="rounded border border-primary-500 bg-primary-500 px-2 py-1 text-[16px] text-white"-->
                                    <!--                                    >-->
                                    <!--                                        {{ question.focus_area.title }}-->
                                    <!--                                    </div>-->

                                    <div
                                        v-if="question.is_tei"
                                        class="rounded border border-primary-500 px-2 py-1 text-[16px] text-primary-500"
                                    >
                                        Technology Enhanced Item
                                    </div>
                                    <!--                                    <div-->
                                    <!--                                        class="rounded border border-gray-700 px-2 py-1 text-[16px] text-gray-700"-->
                                    <!--                                    >-->
                                    <!--                                        Level {{ question.difficulty_level }}-->
                                    <!--                                    </div>-->
                                </div>
                                <div class="mb-8 text-gray-700">
                                    <span v-html="question.content"></span>
                                </div>

                                <div class="flex flex-col gap-3">
                                    <student-quiz-question-answer
                                        v-for="answer in question.shuffled_answers"
                                        :key="answer.id"
                                        :answer="answer"
                                        :selected="getAnswerSelected(answer)"
                                        v-on:set-answer="setAnswer"
                                    >
                                    </student-quiz-question-answer>
                                </div>
                            </div>
                        </div>
                        <div
                            class="fixed bottom-0 mt-8 flex w-full justify-center gap-4 bg-white p-4 shadow-top md:relative md:mt-4 md:bg-transparent md:shadow-none"
                        >
                            <div
                                v-if="canShowSubmitQuestionBtn()"
                                class="w-1/2 rounded bg-primary-525 px-4 py-3 text-center text-white hover:cursor-pointer hover:bg-primary-600 md:w-auto"
                                @click="submitQuestionAnswer()"
                            >
                                Submit
                            </div>
                            <div
                                v-else-if="!canShowSubmitQuestionBtn()"
                                class="w-1/2 rounded bg-primary-525 px-4 py-3 text-center text-white opacity-25 hover:cursor-not-allowed hover:bg-primary-600 md:w-auto"
                            >
                                Submit
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex flex-col items-center justify-center gap-2 py-4 pb-24 text-[19px] text-gray-700 lg:flex-row lg:gap-8 lg:pb-0"
                >
                    <div class="flex items-center gap-2">
                        <div class="">Time Started:</div>
                        <div
                            class="rounded-full border border-gray-400 px-3 py-1 text-[17px] text-gray-600"
                        >
                            {{
                                quizStartTime
                                    .utc(false)
                                    .tz($page.props.display_timezone)
                                    .format($page.props.date_formats.full_nice)
                            }}
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <div>Finish By:</div>
                        <div
                            class="rounded-full border border-gray-400 px-3 py-1 text-[17px] text-gray-600"
                        >
                            {{
                                quizEndTime
                                    .utc(false)
                                    .tz($page.props.display_timezone)
                                    .format($page.props.date_formats.full_nice)
                            }}
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <div class="">Time Remaining:</div>
                        <div
                            class="rounded-full border border-gray-400 px-3 py-1 text-[17px] text-gray-600"
                        >
                            {{ minutesRemaining }} min
                        </div>
                    </div>
                </div>
            </div>

            <confirm-dialog
                ref="quizExitWarningConfirmDialog"
                confirm-button-label="Exit Quiz"
                confirm-button-css="rounded border bg-red-400 px-3 py-2 text-white hover:cursor-pointer hover:bg-red-300"
                cancel-button-label="Cancel"
                cancel-button-css="rounded border border-gray-700 px-3 py-2 text-gray-700 hover:cursor-pointer hover:bg-gray-300"
                v-on:confirm="exitConfirmed"
            >
                <template #content>
                    <div class="flex flex-col">
                        <div class="text-[16px] font-semibold text-gray-925">
                            Are you sure you want to exit?
                        </div>
                        <div class="text-[16px] text-gray-700">
                            If you exit this quiz, your progress will be saved,
                            however, if you do not complete this quiz before
                            <span class="whitespace-nowrap font-semibold">
                                {{
                                    dayjs(quizEndTime)
                                        .utc(false)
                                        .tz($page.props.display_timezone)
                                        .format(
                                            $page.props.date_formats.full_nice
                                        )
                                }}
                            </span>
                            you will forfeit this attempt.
                        </div>
                    </div>
                </template>
            </confirm-dialog>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";
import StudentQuizQuestionAnswer from "@/Components/StudentQuizQuestionAnswer.vue";
import ConfirmDialog from "@/Components/ConfirmDialog.vue";
import dayjs from "dayjs";
import StudentComputerAdaptiveTestDebugger from "@/Pages/NewStudentBackend/StudentComputerAdaptiveTestDebugger.vue";

export default {
    name: "StudentComputerAdaptiveTestShow",
    components: {
        StudentComputerAdaptiveTestDebugger,
        ConfirmDialog,
        StudentQuizQuestionAnswer,
        StudentBackendFocusLayout,
    },
    props: {
        catAttempt: {
            type: Object,
            default: {},
        },
        question: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            showQuiz: false,
            quizTimer: null,
            questionTimer: null,
            minutesRemaining: 0,
            hideTimerWarning: false,
            selectedQuestionAnswers: [],
            optionOrder: [],
            timeSpent: 0,
        };
    },
    methods: {
        dayjs,
        startQuizTimer() {
            let vm = this;
            vm.quizTimer = setInterval(function () {
                vm.updateMinutesRemaining();
            }, 1000 * 30);

            vm.questionTimer = setInterval(function () {
                vm.timeSpent++;
            }, 1000);
        },
        submitQuestionAnswer() {
            let vm = this;

            this.$inertia.get(
                route("student.computer-adaptive-test.submit-question"),
                {
                    question_id: vm.question.id,
                    student_answer: vm.selectedQuestionAnswers,
                    time_spent: vm.timeSpent,
                    option_order: vm.optionOrder,
                },
                {
                    only: ["catAttempt", "question"],
                    onSuccess: function (response) {},
                }
            );
        },
        setAnswer: function (answerId) {
            if (this.question.is_tei) {
                if (_.includes(this.selectedQuestionAnswers, answerId)) {
                    this.selectedQuestionAnswers.splice(
                        this.selectedQuestionAnswers.indexOf(answerId),
                        1
                    );
                } else {
                    this.selectedQuestionAnswers.push(answerId);
                }
            } else {
                this.selectedQuestionAnswers = [answerId];
            }

            this.$forceUpdate();
        },
        getAnswerSelected: function (answer) {
            let vm = this;

            return !!(
                vm.selectedQuestionAnswers.length &&
                _.includes(vm.selectedQuestionAnswers, answer.id)
            );
        },
        canShowSubmitQuestionBtn: function () {
            return this.selectedQuestionAnswers.length;
        },
        updateMinutesRemaining: function () {
            let vm = this;

            vm.minutesRemaining = dayjs(vm.quizEndTime).diff(
                dayjs(),
                "minutes"
            );

            if (vm.minutesRemaining <= 0) {
                vm.$inertia.get(
                    route("student.computer-adaptive-test.end-cat"),
                    {
                        reason: "timer-expired",
                    }
                );
            }
        },
        warnBeforeExitingQuiz: function () {
            this.$refs.quizExitWarningConfirmDialog.openDialog();
        },
        exitConfirmed() {
            this.$inertia.get(route("student.computer-adaptive-test.index"));
        },
        exitQuiz() {
            // tktk this mostly doesn't work because of browser security, if they click exit sure, but all other forms of leaving the page are hard to block/confirm.
            this.warnBeforeExitingQuiz();
        },
    },
    computed: {
        pageTitle() {
            return (
                "Computer Adaptive Test - " +
                this.$page.props.auth.user.provider_level.title
            );
        },
        quizStartTime() {
            return dayjs(this.catAttempt.started_at);
        },
        quizEndTime() {
            return dayjs(this.catAttempt.started_at).add(
                this.catAttempt.allowed_time,
                "minutes"
            );
        },
    },
    mounted() {
        let answerKeys = [];
        this.question.shuffled_answers.forEach(function (answer) {
            answerKeys.push(answer.id);
        });
        this.optionOrder = answerKeys;

        this.updateMinutesRemaining();
        this.startQuizTimer();
        this.showQuiz = true;
    },
    unmounted() {
        clearInterval(this.quizTimer);
        clearInterval(this.questionTimer);
    },
};
</script>
